import * as React from "react";
import { Form } from "react-bootstrap";
import RushProcessing from "../form/RushProcessing";

export default function ComprehensiveSearchStep4({ state, onChange, trademarkRushProcessing, validated }) {
  return (
    <div className="question step-6">
      <Form id="TrademarkForm" noValidate validated={validated}>
        <RushProcessing trademarkRushProcessing={trademarkRushProcessing} onChange={onChange} state={state} label={"We know time is critical. With Rush Processing, we will complete your search results by the next business day."}/>
      </Form>
    </div>
  );
}
